"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginDefinition_1 = require("../PluginDefinition");
/**
 * Error handler plugin definition.
 */
class ErrorHandlerPluginDefinition extends PluginDefinition_1.default {
    /**
     * @inheritDoc
     */
    static getType() {
        return "error_handler";
    }
}
exports.default = ErrorHandlerPluginDefinition;
